/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

#PatientEducation {
  display: grid;
  width: 100%;

  #patient-education-header {
    padding: 8px 8px 10px;
    align-items: center;
    font-weight: bold;
  }

  .patient-education-button-list {
    border: variables.$color-corpuls-secondary-50 solid 1px;
    border-radius: 4px;
    padding-top: 0;
    padding-bottom: 0;
  }
}
